import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const getImagesState = (state: RootState) => state.images;

export const getImagesItems = createSelector(getImagesState, (state) => {
  return state.items;
});
